import { render } from "./PartsModal.vue?vue&type=template&id=303f3f0c&scoped=true"
const script = {}

import "./PartsModal.vue?vue&type=style&index=0&id=303f3f0c&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303f3f0c"]])

export default __exports__